import React from "react";

import { Box, Flex, Heading, Text, useMediaQuery } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import contentSelectors from "@/store/content/content.selectors";
import {
  h_400_14_135_28,
  h_400_14_135_56,
  h_700_14_120_28,
} from "@/styles/fontStyles";

// const customBarStyle = {
//   fill: "#134E88",
//   fillOpacity: 1,
//   cursor: "pointer",
//   transition: "fill 0.3s",
// };

function CustomBar(props) {
  const { fill, x, y, width, height } = props;

  const radius = 4;

  return (
    <path
      d={`M${x},${y + radius} L${x},${y + height} L${x + width},${
        y + height
      } L${x + width},${y + radius} Q${x + width},${y} ${
        x + width - radius
      },${y} L${x + radius},${y} Q${x},${y} ${x},${y + radius} Z`}
      fill={fill}
    />
  );
}

function ChartFund_2() {
  const [isMobile] = useMediaQuery("(max-width: 767px)");
  const [isTablet] = useMediaQuery("(max-width: 1440px)");
  // const selectedCard = useSelector(
  //   contentSelectors.getSelectedCardAnalyzeFund()
  // );
  const selectedCardTable2 = useSelector(
    contentSelectors.getSelectedCardAnalyzeFund2()
  );

  const defaultCard = useSelector(contentSelectors.getDefaultCardAnalyzeFund());

  // Initialize selectedCard with defaultCard if not available
  const currentCard = selectedCardTable2 || defaultCard;

  const dataBenchmark = [
    { value: 39 },
    { value: 15 },
    { value: 10 },
    { value: 25 },
    { value: 4 },
  ];

  const graphData =
    currentCard && currentCard?.graph
      ? Object.entries(currentCard?.graph).map(([label, value], index) => ({
          label: label.slice(0, 10),
          Fund: value,
          Benchmark: dataBenchmark[index]?.value || 0,
        }))
      : [];

  const updatedChartData = {
    chartText: {
      title: "Profitability Relative to Peers Graph",
      text: `Analyzing all of the known holdings of the fund, we find their portfolio companies have a relative level of profitability that is comparable to their competitors/peer groups (that is, not better or worse).`,
      noteText: "Learn more about our methodology",
    },
  };

  return (
    <div>
      <ResponsiveContainer
        width={isMobile ? "100%" : isTablet ? 552 : "100%"}
        height={isMobile ? 150 : isTablet ? 282 : 300}
      >
        {currentCard?.graph ? (
          <BarChart
            width="100%"
            height={300}
            data={graphData}
            margin={{
              top: 20,
              right: 40,
              left: 0,
              bottom: 5,
            }}
          >
            <CartesianGrid
              strokeDasharray="3 0"
              horizontal={true}
              vertical={false}
            />

            <XAxis dataKey="label" angle={0} textAnchor="middle" />
            <YAxis
              yAxisId="left"
              orientation="left"
              stroke="#8884d8"
              tickFormatter={(value) => `${value}%`}
              tick={{ fontSize: 12, fill: "#555" }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              stroke="#82ca9d"
              hide={true}
            />
            <Tooltip />
            {/* <Legend /> */}
            <Bar
              yAxisId="left"
              dataKey="Fund"
              fill="#134E88"
              shape={<CustomBar />}
            />

            <Bar
              yAxisId="right"
              dataKey="Benchmark"
              fill="#0A2540"
              shape={<CustomBar />}
            />
          </BarChart>
        ) : (
          <Flex w={"100%"} h={"200px"} align={"center"} justify={"center"}>
            <Text
              fontSize={"18px"}
              fontWeight={"600"}
              lineHeight={"1"}
              letterSpacing={"4%"}
              color={"gray"}
            >
              No data for graphing!
            </Text>
          </Flex>
        )}
      </ResponsiveContainer>

      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        textAlign={"center"}
        mt={"24px"}
        gap={"16px"}
      >
        <Text {...h_400_14_135_28}>Relative Profitability</Text>
        <Flex alignItems={"center"} justifyContent={"center"}>
          <Box
            mr={"10px"}
            w={"40px"}
            height={"4px"}
            borderRadius={"4px"}
            backgroundColor={"#134E88"}
          ></Box>
          <Text {...h_400_14_135_28} mr={"10px"}>
            Fund
          </Text>
          <Box
            w={"40px"}
            height={"4px"}
            borderRadius={"4px"}
            backgroundColor={"#0A2540"}
            mr={"10px"}
          ></Box>
          <Text {...h_400_14_135_28}>Benchmark</Text>
        </Flex>
      </Flex>
      <Heading mt={"16px"} as={"h2"} {...h_700_14_120_28} color={"mainBlue"}>
        {updatedChartData?.chartText?.title}
      </Heading>
      <Text mt={"16px"} color={"naturalBlack"} {...h_400_14_135_56}>
        {updatedChartData?.chartText?.text}
      </Text>
    </div>
  );
}

export default ChartFund_2;
